module.exports = __webpack_public_path__ + "src/assets/img/visual_70years_welcome.1dbe5c1e.png";